module.exports = __webpack_public_path__ + "img/744.7130a170.jpg";